<button
  mat-flat-button
  class="secondary"
  (click)="backBtnClickEvent()"
  [attr.aria-label]="'Back. Go to step ' + previousStepNumber + ' of ' + totalSteps">{{buttonText}}</button>
